import { GameEvent } from '../events/gameEvent';
import { EventName } from '../events/eventsName';
import { SoundManager } from '../core/soundManager';
import { Store } from 'game/store/gameStore';
import { GameActionButton } from './GameActionButton';

export class UndoButton extends GameActionButton {
    constructor(index: number) {
        super('undo', index);
        GameEvent.add(EventName.SET_UNDO_DISABLED, this.setDisabled);
        GameEvent.add(EventName.CTR_Z, this.action);
    }

    onClick() {
        SoundManager.play('undoSFX');
        GameEvent.emit(EventName.UNDO_TRIGGERED);
        Store.setUndoCounter(Store.undoCounter - 1);
    }

    getStoreCounter() {
        return Store.undoCounter;
    }
}
